package article.spring

import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.spring
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.Button
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.scale
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp


const val SPRING_SCALE_BALL = "4e1fda187763f8628d3e0130ef219ed6ffd83ac396d075a17f6c5d3c5e38ef4f"

@Composable
fun SpringScaleBall() {

    SpringGrid {
        Row(
            Modifier.fillMaxSize()
        ) {

            var expanded by remember { mutableStateOf(false) }

            val scale by animateFloatAsState(
                targetValue = if (expanded) 1f else .3f,
                animationSpec = spring(),
                visibilityThreshold = .001f
            )

            Box(Modifier.fillMaxHeight().weight(1f), contentAlignment = Alignment.Center) {
                Orb(
                    Modifier
                        .padding(16.dp)
                        .scale(scale)
                        .aspectRatio(1f)
                        .fillMaxSize()
                )
            }

            SpringButton(
                modifier = Modifier.align(Alignment.CenterVertically),
                onClick = {
                    expanded = !expanded
                }
            ) {
                Text("Animate", color = Color.Black)
            }
        }

    }
}